/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import { SEARCH_COLUMNS } from './utils/list_data';
import { useLocation } from 'react-router-dom';
import { formatDate } from 'src/utils/dates';
import { apiGenerealSearchResults } from 'src/api/modules/searches';
import notice from 'src/common/components/Notice';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';
import { usePagination } from 'src/hooks/usePagination';

const AdvancedSearch = () => {
	const history = useHistory();
	const [searchResults, setSearchResults] = useState([]);
	const [arrayOrgan, setArrayOrgan] = useState([]);
	const [accessAll, setAccessAll] = useState(false);
	const search = useLocation().search;
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	let searchQueryParam = new URLSearchParams(search).get('s');
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const showEverything = [
		'ADMINISTRADOR GENERAL',
		'SISTEMA',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE SEGUIMIENTO',
	];
	const {
		pagination,
		handlePagination,
		currentPage,
		setCurrentPage,
		totalResults,
		setTotalResults,
	} = usePagination();

	useEffect(() => {
		fetchResults();
		let newArray = [];
		reduxOrgan.forEach((item) => {
			newArray.push(item.value);
		});
		setArrayOrgan(newArray);

		if (showEverything.includes(systemLevelRole) === true) setAccessAll(true);
		else setAccessAll(false);
	}, [searchQueryParam, pagination, currentPage]);

	const fetchResults = () => {
		notice('Búsqueda en Proceso', 'info');
		apiGenerealSearchResults
			.getGenerealSearchResults(searchQueryParam, pagination, currentPage)
			.then((response) => {
				if (response.temas.length > 0) {
					setTotalResults(response.totalRegistros);
					let newResponse = [];
					response.temas.forEach((item) => {
						newResponse.push({
							...item,
							dateSesion: moment(item.fechaSesion).format('DD/MM/YYYY'),
							dateLimit: item.fechaLimite.split('-').reverse().join('/'),
						});
					});

					setSearchResults(newResponse);
				} else {
					notice('No se encontraron resultados', 'warning');
					setSearchResults([]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const onEye = (id) => history.push(`/seguimiento/resolucion/${id}`);

	const expandRow = (data) => {
		let textdata = (
			<div style={{ maxWidth: '100%' }}>
				<p>
					<b>Número: </b> {data.id}
				</p>
				<p>
					<b>RESOLUCIÓN: </b> {data.numeroResolucion}
				</p>
				<p>
					<b>TEXTO: </b> {data.texto}
				</p>
				<p>
					<b>ÓRGANO COLEGIADO: </b> {data.comite}
				</p>
				<p>
					<b>NÚMERO DE SESIÓN: </b> {data.numeroSesion}
				</p>
				<p>
					<b>FECHA DE SESIÓN: </b> {data.dateSesion}
				</p>
				<p>
					<b>FECHA DE CUMPLIMIENTO: </b> {data.dateLimit}
				</p>
				<p>
					<b>ÁREA RESPONSABLE: </b> {data.areaResponsable}
				</p>
				<p>
					<b>ÁREA ACOMPAÑAMIENTO: </b> {data.areaAcompanante}
				</p>
				<p>
					<b>DOCUMENTOS DE ÁREA: </b> {data.nombreDocumentos}
				</p>
				<p>
					<b>ESTATUS: </b> {data.estatus}
				</p>
			</div>
		);

		return textdata;
	};

	return (
		<PageLayout title={`Resultados de la búsqueda para: ${searchQueryParam}`}>
			<FullTable
				items={searchResults}
				columns={SEARCH_COLUMNS(onEye, arrayOrgan, accessAll)}
				ExcelFileName={`Búsqueda_General_${formatDate('P p')}.xls`}
				expand={true}
				dataRow={expandRow}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
		</PageLayout>
	);
};

export default AdvancedSearch;
